export default "__VITE_ASSET__Cdc62aem__"